import {connect} from "react-redux";
import LeadAddressUpdateLogs from "./AddressUpdateLogs";
import {bindActionCreators} from "redux";
import {getAddressUpdateLogsRequest} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    addressUpdateLogsResponse:state.Lead.getAddressUpdateLogsResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAddressUpdateLogsRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadAddressUpdateLogs);
